import { render, staticRenderFns } from "./mainSect.vue?vue&type=template&id=354f2344&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f2344",
  null
  
)

export default component.exports